import React from 'react';

export const TrashIcon = ({ width = 16, height = 16, color = "#CC0000", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                className={className}
                d="M4.66669 14C4.30002 14 3.98624 13.8696 3.72535 13.6087C3.46446 13.3478 3.3338 13.0338 3.33335 12.6667V4H2.66669V2.66667H6.00002V2H10V2.66667H13.3334V4H12.6667V12.6667C12.6667 13.0333 12.5362 13.3473 12.2754 13.6087C12.0145 13.87 11.7005 14.0004 11.3334 14H4.66669ZM11.3334 4H4.66669V12.6667H11.3334V4ZM6.00002 11.3333H7.33335V5.33333H6.00002V11.3333ZM8.66669 11.3333H10V5.33333H8.66669V11.3333Z"
                fill={color}
            />
        </svg>
    );
};